import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import {Provider as AlertProvider} from 'react-alert';

import { Portals } from 'constants/constants';

import reducer from 'store/reducer';
import { history } from 'store/RouteState';
import { createAppStore } from 'store/store';

import App from 'App'
import Toast, {ToastDefaults} from 'components/Toast';

const store = createAppStore(reducer, window.__INITIAL_STATE__);

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <div id={Portals.STRIPE} />
      <div id={Portals.TOOLTIP} />
      <div id={Portals.POPUP} />
      <AlertProvider template={Toast} {...ToastDefaults}>
        <App></App>
      </AlertProvider>
    </Router>
  </Provider>, 
  document.getElementById('appRoot'));
